import styled from "@xstyled/styled-components"

import { MainLink } from "@atoms/Typography"

export const StyledFooter = styled.footerBox`
  background-color: light;
`

export const StyledLink = styled(MainLink)``
